import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LobItem {
  id: string;
  name: string;
  display_name: string;
  description: string;
  created_at: string;
  status: boolean;
  updated_at: string;
}

export interface ListLobResult {
  total: number;
  page: number;
  page_size: number;
  data: LobItem[];
}

export interface ListLobPayload {
  data?: {
    message?: string;
    result?: ListLobResult;
  };
}

export interface LobDataOption {
  id: string;
  name: string;
}

export interface ListLobState {
  lobResult: ListLobResult | null;
  lobData: LobDataOption[];
}

const initialState: ListLobState = {
  lobResult: null,
  lobData: [],
};

const listLobSlice = createSlice({
  name: "listLob",
  initialState,
  reducers: {
    setListLob: (state, action: PayloadAction<ListLobPayload>) => {
      const result = action.payload?.data?.result ?? null;
      state.lobResult = result;
      state.lobData =
        result?.data?.map((item) => ({
          id: item.id,
          name: item.display_name,
        })) ?? [];
    },
    resetListLob: (state) => {
      state.lobResult = null;
      state.lobData = [];
    },
  },
});

export const { setListLob, resetListLob } = listLobSlice.actions;
export default listLobSlice.reducer;
